const FormatDateTime = (dataAtual, withUtc = true) => {
  if (withUtc === true) {
    const data = new Date(dataAtual);

    const dataUTC3 = new Date(data.getTime() - 3 * 60 * 60 * 1000);

    const dia = String(dataUTC3.getDate()).padStart(2, "0");
    const mes = String(dataUTC3.getMonth() + 1).padStart(2, "0");
    const ano = dataUTC3.getFullYear();

    const hora = String(dataUTC3.getHours()).padStart(2, "0");
    const minutos = String(dataUTC3.getMinutes()).padStart(2, "0");
    const segundos = String(dataUTC3.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`;
  }
  const data = new Date(dataAtual);

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();

  const hora = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");
  const segundos = String(data.getSeconds()).padStart(2, "0");

  return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`;
};

export default FormatDateTime;
